<form class="form-popup" [formGroup]="formGroup">
    <h5>{{ itemToReturn.inventoryItem.description }}</h5>
    <mat-form-field appearance="fill">
        <mat-label>Quantity to Return</mat-label>
          <input matInput type="number" name="Quantity Returned"
                          class="fullWidth"
                          [min]="0"
                          [max]="maxReturnableQuantity"
                          formControlName="returnedQuantity"
          />
    </mat-form-field>
</form>
